 function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } }import graphql from 'babel-plugin-relay/macro'
import {Link} from 'react-router-dom'
import React, {useEffect} from 'react'
import {useFragment} from 'react-relay'

import NotificationTemplate from './NotificationTemplate'
import useAtmosphere from '../hooks/useAtmosphere'
import SendClientSideEvent from '../utils/SendClientSideEvent'
import anonymousAvatar from '../styles/theme/images/anonymous-avatar.svg'





const KudosReceivedNotification = (props) => {
  const atmosphere = useAtmosphere()
  const {notification: notificationRef} = props
  const notification = useFragment(
    graphql`
      fragment KudosReceivedNotification_notification on NotifyKudosReceived {
        ...NotificationTemplate_notification
        id
        type
        name
        picture
        meetingName
        meetingId
        emojiUnicode
        status
      }
    `,
    notificationRef
  )
  const {type, name, picture, meetingName, emojiUnicode, meetingId, status} = notification

  useEffect(() => {
    SendClientSideEvent(atmosphere, 'Notification Viewed', {
      notificationType: type,
      notificationStatus: status
    })
  }, [])

  return (
    React.createElement(NotificationTemplate, {
      message: 
        React.createElement(React.Fragment, null
          , emojiUnicode, " " , _nullishCoalesce(name, () => ( 'Someone')), " gave you kudos in"    , ' '
          , React.createElement(Link, { to: `/meet/${meetingId}`, className: "font-semibold text-sky-500 underline"  ,}
            , meetingName
          )
        )
      ,
      notification: notification,
      avatar: _nullishCoalesce(picture, () => ( anonymousAvatar)),}
    )
  )
}

export default KudosReceivedNotification
